import React from 'react'

import { Translate } from '@hozana/intl/Translate'

import { TTextProps, Text } from 'elements/text/Text'

import { TCounts, getSharesCountTotal } from 'modules/share/functions'

export type TShareCountProps = { counts: TCounts } & TTextProps

export const ShareCount: TFCC<TShareCountProps> = ({ counts, fontSize = '1em', color = 'black50', ...otherProps }) => (
  <Text fontSize={fontSize} color={color} {...otherProps}>
    <Translate values={{ count: getSharesCountTotal(counts) }}>trans:share:share.count</Translate>
  </Text>
)
